export default {
  "content": "<title>Play Back</title><path d=\"M496 400L256 256l240-144v288zm-240 0L16 256l240-144v288z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};